import { useTranslation } from 'react-i18next';
import { useAllPicUserOptions } from '@anytag/shared-hooks';
import { MultipleSelectorFieldProps, SelectorField } from '@anytag/shared-molecules';
import { MarketplaceFormKeys } from '../types';

export const SalePICField = (
  props: Omit<MultipleSelectorFieldProps<MarketplaceFormKeys>, 'name' | 'options' | 'multiple'>
) => {
  const { t } = useTranslation();
  const { allPicsUserOptions } = useAllPicUserOptions({ fetchPolicy: 'cache-first' });

  return (
    <SelectorField
      hasSelectAll={false}
      title={t('Selector.Sales PIC')}
      help={t('Tooltip.Sales PIC')}
      options={allPicsUserOptions}
      name={MarketplaceFormKeys.salesPicIds}
      multiple
      {...props}
    />
  );
};
